import { useEffect, useRef } from "react";
import { api } from "../../lib/api";

let googlePromise = null;
function loadGoogle(key) {
  if (window.google?.maps?.places) return Promise.resolve();
  if (googlePromise) return googlePromise;
  googlePromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
    s.async = true;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
  return googlePromise;
}

// Full-address input. Uses Google Places autocomplete when the key is connected; plain text otherwise.
export function AddressInput({ value, onChange, required, testId = "address-input", className = "", placeholder = "Full street address *" }) {
  const inputRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    let listener = null;
    api.get("/public-config").then(({ data }) => {
      const key = data?.places_key;
      if (!key || cancelled) return;
      loadGoogle(key).then(() => {
        if (cancelled || !window.google?.maps?.places || !inputRef.current) return;
        const ac = new window.google.maps.places.Autocomplete(inputRef.current, {
          componentRestrictions: { country: "au" },
          fields: ["formatted_address"],
          types: ["address"],
        });
        listener = ac.addListener("place_changed", () => {
          const p = ac.getPlace();
          if (p?.formatted_address) onChange(p.formatted_address);
        });
      }).catch(() => {});
    }).catch(() => {});
    return () => { cancelled = true; if (listener) listener.remove?.(); };
  }, []); // eslint-disable-line

  return (
    <input ref={inputRef} data-testid={testId} className={className} required={required}
      placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} autoComplete="off" />
  );
}
